// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__30vrA","toggle":"styles_toggle__2iYgf","preview":"styles_preview__Z4KDO"};